import ConfigWidgetLabel from 'scoreboard/dashboards/widgets/config-widget-label'
import i18n from 'scoreboard/components/i18n'
import OnOffToggle from 'scoreboard/components/on-off-toggle'
import _ from 'lodash'
import pieLike from 'scoreboard/charts/pie-like'

/**
 * View for editing a chart's label
 */
var LabelView = ConfigWidgetLabel.extend({
	dialogTitle: 'charts.setLabel',

	_getModelLabel: function () {
		return this.model.properties.get('label')
	},

	_setModelLabel: function (label) {
		this.model.properties.set('label', label)

		this.model.properties.set('showPeriodLabel',
			this.showingToggle() ? this.periodToggle.val() : false)
	},

	_getSuggestion: function () {
		return ''
	},

	render() {
		ConfigWidgetLabel.prototype.render.apply(this, arguments)

		// #18747 if the chart displays a single period, give the user the
		// "Show Calendar Period" toggle
		// #23492 or if it's a pie chart of any number of periods
		// #41174 this was removed, but we decided to bring it back for the time being
		if (this.showingToggle()) {
			this.periodToggle = new OnOffToggle({
				name: 'showPeriodLabel',
				checked: this.model.properties.get('showPeriodLabel'),
				label: i18n.get('charts.showPeriodLabel')
			})

			this.$('.widget-title').after(this.periodToggle.el)
			this.periodToggle.render()
		}

		return this
	},

	showingToggle: function() {
		return this.model.chart.isSinglePeriod() || pieLike(this.model.chart)
	},

	remove: function() {
		ConfigWidgetLabel.prototype.remove.apply(this, arguments)
		_.invokeMap([this.periodToggle], 'remove')
	}
})

export default LabelView

LabelView.__filename__ = 'dashboards/widgets/chart/config/chart-label.js'
